import axios from 'axios';
import { StyledDocumentItem } from '../../../document-download/DocumentDownload.styled';

import {
  CreateFileSignRequestAction,
  DeleteFileSignRequestAction,
  DeleteSignatureImageCustomerAction,
  SaveFeedbackAction,
  StoreAction,
  UpdateNoteAction,
  UploadSignatureImageCustomerAction,
  UploadSignedFileCustomerAction,
} from '../../../../app/ActionsImpl';

import { DeleteOutlined, EditOutlined, StarTwoTone } from '@ant-design/icons';
import { Button, Card, Checkbox, Divider, Modal, Row, Spin, Tooltip } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import ecofriendly from '../../../../images/ecofriendly.webp';
import { saveAs } from 'file-saver';
import React, { useEffect, useRef, useState } from 'react';
import { isChrome, isFirefox, isIE, isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Dropdown, Icon, Segment, Table } from 'semantic-ui-react';
import { AppState } from '../../../../app/AppState';
import { COMPANY_LOOKUP_HOST } from '../../../../constants';
import DitecSigner from '../../../../utils/DitecSigner';
import { getAllUrlParams } from '../../../../utils/url';
import { feedbacks } from '../../../admin/pages/Feedback.page';
import { OrderState, OrderStateSteper, OrderStateText } from '../../../admin/pages/Interfaces';
import { DitecModal } from '../../components/DitecModal';
import { DocumentDownloadOverview } from './UserOrderListDocumentOverview';
import { translations } from '../../../../utils/LocalizedStrings';
import JSZip from 'jszip';

import ReactSignatureCanvas from 'react-signature-canvas';
import { InviteModal } from '../../components/InviteModal';

export interface Props extends StateProps, DispatchProps {
  data: { id: string } & any;
  token: any;
  refresh: () => void;
  labels: {
    nameOfSro?: string;
    identifier?: string;
    stateOfOrder?: string;
    dateOfCreate?: string;
  };
}

function UserOrderItem({
  data,
  token,
  labels,
  uploadSignedFile,
  uploadSignatureImage,
  deleteSignatureImage,
  refresh,
  saveFeedback,
  createFileSignRequest,
  deleteFileSignRequest
}: Props,) {
  const [downloadingFiles, setDownloadingFiles] = useState<any>([]);
  let feedback = feedbacks[Math.floor(Math.random() * feedbacks.length)];
  const [showDetail, setShowDetail] = useState(false);
  const [formState, setFormState] = useState<any>({});
  const [loading, setLoading] = useState(false)
  const [errorCode, setErrorCode] = useState()
  const [errorSubCode, setErrorSubCode] = useState()
  const [signing, setSigning] = useState(false)
  const [invited, setInvited] = useState([""])

  const [stepperIndex, setStepperIndex] = useState(0)

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState(feedback);
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);

  const [showSignatures, setShowSignatures] = useState<any[]>([])
  const [noneSignedDocuments, setNoneSignedDocuments] = useState<any[]>([])
  const [documentsToSign, setDocumentToSign] = useState<{ [Key: string]: any[] }>({});
  const [filesToSign, setFilesToSign] = useState<any>([]);
  const [inviteModalVisible, setInviteModalVisible] = useState(false)
  const [signatureModalVisible, setSignatureModalVisible] = useState<any>({})
  const [modalButtonDisabled, setModalButtonDisabled] = useState(false)
  const [missingSignatures, setMissingSignatures] = useState<any[]>([])

  let sigPad = useRef<ReactSignatureCanvas | null | undefined>()

  useEffect(() => {
    let noneSignedDocuments = []
    let tmpdoc: { [Key: string]: any[] } = {}
    if (data && data.downloads) {
      for (let download of data.downloads) {
        if (!download.requiredSignatures || download.requiredSignatures.length === 0) {
          noneSignedDocuments.push(download)
        } else {
          for (let signature of download.requiredSignatures) {
            if (tmpdoc[signature]) {
              tmpdoc[signature].push(download)
            } else {
              tmpdoc[signature] = [download]
            }
          }
        }
      }
    }
    setNoneSignedDocuments(noneSignedDocuments)
    setDocumentToSign(tmpdoc)
  }, [data])

  useEffect(() => {
    if (data.formState) {
      setFormState(JSON.parse(data.formState))
    } else if (data.template) {
      setFormState(JSON.parse(data.template).template)
    }
  }, [data])

  useEffect(() => {
    const urlParams: any = getAllUrlParams()
    if (urlParams.order === data._id) {
      setShowDetail(true)
    }
  }, [])

  useEffect(() => {
    let found = false;

    if (data.orderStatus &&
      data.orderStatus.history &&
      OrderState[data.orderStatus.history[data.orderStatus.history.length - 1].state as keyof typeof OrderState]) {
      Object.keys(OrderState).forEach((k, index) => {

        if (k === data.orderStatus.history[data.orderStatus.history.length - 1].state) {
          found = true;
          setStepperIndex(Number(OrderStateSteper[k as keyof typeof OrderState]) + 2);
        }
      })
    }
    if (!found) {
      setStepperIndex(1)
    }
  }, [showDetail]);

  const handleTriggerDownload = async (documentItem: any, id: any, extension: any) => {
    const filename = documentItem.name;
    await axios
      .get(
        `${COMPANY_LOOKUP_HOST}/userorder/download-file/${id}/${documentItem.id}`,
        {
          responseType: 'blob',
        },
      ).then((res) => {
        saveAs(res.data, filename + extension);
      });
  };

  const textarea = Array.from(document.querySelectorAll('textarea'));
  if (textarea) {
    textarea.map((area) => {
      area.addEventListener('focus', (e: any) => {
        area.style.height = '65px';
        let scHeight = e.target.scrollHeight;
        area.style.height = `${scHeight}px`;
      });
      area.addEventListener('blur', (e: any) => {
        area.style.height = '63px';
      });
    });
  }

  const handleModalClose = () => {
    setErrorCode(undefined)
    setErrorSubCode(undefined)
    setLoading(false)
  }

  const errorFunction = (error: any) => {
    if (error) {
      if (error.code !== 1) {
        setErrorCode(error.code)
        if (error.cause) {
          setErrorSubCode(error.cause.code)
        }
      }
    }
    setLoading(false)
  }

  const callbackFunction = async (response: any) => {
    console.log("callback", response)
    await uploadSignedFile(response.orderId, response.fileId, response)
    await refresh()
    setLoading(false)
  }
  useEffect(() => {
    console.log(downloadingFiles)
  }, [downloadingFiles])

  const signFile = async (documentItem: any, id: any, signature: any) => {
    const filename = documentItem.name;
    let tmpMissingSignatures = []
    if (documentItem.requiredSignatureImages) {
      if (documentItem.imageSignatures) {
        for (let signature of documentItem.requiredSignatureImages) {
          if (documentItem.imageSignatures.indexOf(signature) === -1) {
            tmpMissingSignatures.push(signature)
          }
        }
        if (tmpMissingSignatures.length > 0) {
          setMissingSignatures(tmpMissingSignatures)
          return
        }
      } else {
        for (let signature of documentItem.requiredSignatureImages) {
          if (!documentItem.imageSignatures || documentItem.imageSignatures.indexOf(signature) === -1) {
            tmpMissingSignatures.push(signature)
          }
        }
        if (tmpMissingSignatures.length > 0) {
          setMissingSignatures(tmpMissingSignatures)
          return
        }
      }
    }
    let newDownloadingFiles = [...downloadingFiles]
    newDownloadingFiles.push(documentItem.id)
    setDownloadingFiles(newDownloadingFiles)
    if (documentItem.signedFile && documentItem.signedFile.key) {
      await axios
        .get(
          `${COMPANY_LOOKUP_HOST}/userorder/download-file/${id}/${documentItem.signedFile.id}`,
          {
            responseType: 'arraybuffer',
          },
        )
        .then((res) => {
          let base64data = Buffer.from(res.data, 'binary').toString('base64');
          let dsigner = new DitecSigner(callbackFunction, errorFunction, signature);
          dsigner.asicAddSignature(base64data, filename, id, documentItem.id);
        })
        .catch((error) => {
          console.error(error);
        });
      newDownloadingFiles = [...newDownloadingFiles]
      newDownloadingFiles.splice(newDownloadingFiles.indexOf(documentItem.id), 1)
      setDownloadingFiles(newDownloadingFiles)
    } else {
      await axios
        .get(
          `${COMPANY_LOOKUP_HOST}/userorder/download-file/${id}/${documentItem.id}`,
          {
            responseType: 'arraybuffer',
          },
        )
        .then((res) => {
          let base64data = Buffer.from(res.data, 'binary').toString('base64');
          let dsigner = new DitecSigner(callbackFunction, errorFunction, signature);
          dsigner.signFile(base64data, filename, id, documentItem.id);
        })
        .catch((error) => {
          console.error(error);
        });
      newDownloadingFiles = [...newDownloadingFiles]
      newDownloadingFiles.splice(newDownloadingFiles.indexOf(documentItem.id), 1)
      setDownloadingFiles(newDownloadingFiles)
    }
    setSigning(true)
  }
  const handleChangeFeedback = (e: any) => {
    setFeedbackMessage(e.target.value);
  };

  const sendFeedback = () => {
    setIsModalOpen(false)
    saveFeedback(data.marketingId, rating, feedbackMessage)
  };

  const resolveFilesToSign = (documentId: any, signature: any) => {
    setFilesToSign([{ documentId, signature }])
  }

  const handleShowSignature = (id: any) => {
    let newShowSignatures = JSON.parse(JSON.stringify(showSignatures))
    if (newShowSignatures.indexOf(id) === -1) {
      newShowSignatures.push(id)
    } else {
      newShowSignatures.splice(newShowSignatures.indexOf(id), 1)
    }
    setShowSignatures(newShowSignatures)
  }

  const clear = () => {
    sigPad?.current?.clear()
  }

  const trim = async (documentItemId: any, signature: any) => {
    let value = sigPad?.current?.getTrimmedCanvas().toDataURL('image/png')
    setModalButtonDisabled(true)
    await uploadSignatureImage(data._id, documentItemId, signature, value)
    setModalButtonDisabled(false)
    await setSignatureModalVisible({ ...signatureModalVisible, [signature]: undefined })
    await clear()
    await refresh()
  }

  const singaturePad = () => {
    return (
      <ReactSignatureCanvas
        canvasProps={{
          className: "signature"
        }}
        ref={(ref) => { sigPad.current = ref }} />
    )
  }

  const renderDocumentItem = (documentItem: any, signature: any) => {
    const { name, uploads, uploadsStatus } = documentItem;
    console.log("Podpis rukou", documentItem.requiredKepSignatures)
    // console.log(documentItem.requiredKepSignatures.indexOf(signature))
    console.log(documentItem.requiredSignatureImages)
    // console.log(documentItem.requiredSignatureImages.indexOf(signature))
    console.log(documentItem.signedFile)
    return (
      <>
        <Spin spinning={downloadingFiles.indexOf(documentItem.id) !== -1} className='userOrderList'>
          <StyledDocumentItem key={`doc-downloadn-${name}`}>
            <div className="ordersDatabaseRow">
              <Row onClick={() => handleShowSignature(documentItem.id)}>
                <span className='ordersDatabaseRowCheckbox'>
                  <div>
                    <strong>{name}</strong>
                    {documentItem.signedFile &&
                      <div className='requestSignatureEmail'>
                        <span className='requestSignatureTitle' style={{ paddingRight: 10 }}>{translations.screens.UserOrderList?.signedBy}</span>
                        {documentItem.signedFile.signatures.map((signature: any) => {
                          return (
                            <div className='documentSignedTag'>
                              <span>{signature.CN}</span>
                              <span>R.č.: {signature.SERIALNUMBER && signature.SERIALNUMBER.split('-')[1]}</span>
                            </div>
                          )
                        })}
                      </div>
                    }
                    {documentItem.imageSignatures && documentItem.imageSignatures.length > 0 &&
                      <div className='requestSignatureEmail'>
                        <span className='requestSignatureTitle' style={{ paddingRight: 10 }}>{translations.screens.UserOrderList?.signedByFinger}</span>
                        {documentItem.imageSignatures?.map((signature: any) => {
                          return (
                            <div className='documentSignedTag'>
                              <span>{signature}</span>
                            </div>
                          )
                        })}
                      </div>
                    }
                    {data.signatureRequests && data.signatureRequests[documentItem.id] &&
                      <div className='requestSignatureEmail'>
                        <span className='requestSignatureTitle' style={{ paddingRight: 10 }}>{translations.screens.UserOrderList?.requestFrom}</span>
                        {data.signatureRequests[documentItem.id].map((signature: any) => {
                          return (
                            <div className='requestSignatureRow'>
                              <Tooltip title={[translations.screens.UserOrderList?.cancelRequestTooltip]} >
                                <Button
                                  onClick={async (e) => {
                                    e.stopPropagation()
                                    await deleteFileSignRequest({ orderId: data._id, recipient: signature, file: documentItem.id })
                                    refresh()
                                  }}
                                  size="small"
                                  type="text"
                                  className='cancelRequestSignatureTag'>
                                  {signature} <DeleteOutlined />
                                </Button>
                              </Tooltip>
                            </div>
                          )
                        })}
                      </div>
                    }
                  </div>
                </span>
                <span className='ordersDatabaseRowButtons'>
                  <DocumentDownloadOverview documentItem={documentItem} token={token} orderId={data._id} />

                  {signature &&
                    <Dropdown floating icon='signup' text={translations.screens.UserOrderList?.signingTitle} className='userProfileOrdersDropdown'>
                      <Dropdown.Menu>
                        <React.Fragment key={signature}>
                          {!isMobile && (isFirefox || isChrome) &&
                            <>
                              {documentItem.requiredKepSignatures && documentItem.requiredKepSignatures.indexOf(signature) !== -1 &&
                                <Dropdown.Item>
                                  <Button
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      signFile(documentItem, data._id, signature)
                                    }}
                                    size="small"
                                    type="primary"
                                    className=''>
                                    {translations.screens.UserOrderList?.sign}
                                  </Button>
                                </Dropdown.Item>
                              }

                              {
                                ((documentItem.imageSignatures && documentItem.imageSignatures.indexOf(signature) !== -1)) &&
                                <Dropdown.Item>
                                  <Button
                                    onClick={async (e) => {
                                      e.stopPropagation()
                                      await deleteSignatureImage(data._id, documentItem.id, signature)
                                      await refresh()
                                    }}
                                    size="small"
                                    type="primary"
                                    className='requestSignatureBtn handSignature'>
                                    {translations.screens.UserOrderList?.deleteSign}
                                  </Button>
                                </Dropdown.Item>
                              }
                            </>
                          }

                          <Dropdown.Item>
                            <span className='chooseDocumentToSignCheckboxContainer'>
                              <Checkbox
                                onClick={(e) => {
                                  e.stopPropagation()
                                  resolveFilesToSign(documentItem.id, signature)
                                  setInviteModalVisible(true)
                                }}
                                className='inviteModalVisibleCheckbox'
                                checked={filesToSign.indexOf(documentItem.id) !== -1}>
                                {translations.screens.UserOrderList?.chooseDocument}
                              </Checkbox>
                            </span>
                          </Dropdown.Item>
                          <Modal
                            key={"modal_img" + signature}
                            className="vopModal signatureModal"
                            title={translations.artifacts.SignatureCanvasArtifact.signature}
                            visible={signatureModalVisible[signature] === documentItem.id}
                            onCancel={() => { setSignatureModalVisible({ ...signatureModalVisible, [signature]: undefined }) }}
                            footer={null}>
                            <div className='signature-wrapper'>
                              {singaturePad()}
                            </div>
                            <div className='buttonsContainer'>
                              {signature}
                              <Button
                                type="primary"
                                onClick={clear}
                                className="addPersonButton clearBtn">
                                {translations.artifacts.SignatureCanvasArtifact.clear}
                              </Button>
                              <Button
                                type="primary"
                                disabled={modalButtonDisabled}
                                onClick={() => trim(documentItem.id, signature)}
                                className="addPersonButton saveBtn">
                                {translations.artifacts.SignatureCanvasArtifact.save}
                              </Button>
                            </div>
                          </Modal>
                          {
                            ((!documentItem.requiredKepSignatures || documentItem.requiredKepSignatures.indexOf(signature) === -1 || (documentItem.requiredSignatureImages && documentItem.requiredSignatureImages.indexOf(signature) !== -1)) && !documentItem.signedFile) &&
                            <Dropdown.Item>
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setSignatureModalVisible({ ...signatureModalVisible, [signature]: documentItem.id })
                                }}
                                size="small"
                                type="primary"
                                className=''>
                                {translations.screens.UserOrderList?.createSign}
                              </Button>
                            </Dropdown.Item>
                          }
                        </React.Fragment>
                      </Dropdown.Menu>
                    </Dropdown>
                  }

                  <Dropdown floating icon='file pdf' text={translations.screens.UserOrderList?.download} className='userProfileOrdersDropdown'>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Button
                          onClick={(e) => {
                            e.stopPropagation()
                            handleTriggerDownload(documentItem, data._id, ".pdf")
                          }}
                          size="small"
                          type="primary"
                          className='pdfSignatureBtn'>
                          {translations.screens.UserOrderList?.download} PDF
                        </Button>
                      </Dropdown.Item>

                      {documentItem.signedFile &&
                        <Dropdown.Item>
                          <Button
                            onClick={(e) => {
                              e.stopPropagation()
                              handleTriggerDownload(documentItem.signedFile, data._id, ".asice")
                            }}
                            size="small"
                            type="primary"
                            className='pdfSignatureBtn'>
                            {translations.screens.UserOrderList?.download} ASICe
                          </Button>
                        </Dropdown.Item>
                      }
                    </Dropdown.Menu>
                  </Dropdown>

                </span>
              </Row>
            </div>
          </StyledDocumentItem>
        </Spin >
      </>
    )
  }

  const handleTriggerDownloadAll = async (documentList: any) => {
    let zip = new JSZip();
    Promise.all(
      documentList.map(async (documentItem: any) => {
        if (!documentItem) {
          return null;
        }
        const { name } = documentItem;
        await axios.get(`${COMPANY_LOOKUP_HOST}/userorder/download-file/${data._id}/${documentItem.id}`, {
          responseType: 'blob',
        },
        ).then((res) => {
          zip.file(name + '.pdf', res.data, { binary: true });
        });
      }),
    ).then(() =>
      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, 'mojezmluvy dokumenty');
      }),
    );
  };

  const sendInvitation = async () => {
    let fileSignRequest = {
      recipients: invited,
      orderId: data._id,
      filesToSign: filesToSign
    }

    await createFileSignRequest(fileSignRequest)
    setInviteModalVisible(false)
    await refresh()
    await setInvited([''])
  }

  const handleInviteModalClose = () => {
    setInviteModalVisible(false)
  }

  return (
    <>
      <InviteModal visible={inviteModalVisible} invited={invited} setInvited={setInvited} sendInvitation={sendInvitation} handleClose={handleInviteModalClose} />
      <DitecModal signing={signing} loading={loading} errorCode={errorCode} errorSubCode={errorSubCode} handleClose={handleModalClose} />
      {data.template === undefined &&
        <Table.Row>
          <Table.Cell onClick={() => {
            console.log(data)
            window.location.href = `/flow/${data.flow_id}?steps=${data?.formData?.selectedSteps?.join(",")}&forder=${data._id.toString()}`
          }}>
            <strong style={{ cursor: 'pointer' }}>Editovať <EditOutlined /></strong>
          </Table.Cell>
          <Table.Cell onClick={() => setShowDetail(!showDetail)} style={{ cursor: 'pointer' }}>
            {showDetail ? <strong>Zatvoriť <Icon disabled name='angle up' /></strong> : <strong>Otvoriť <Icon disabled name='angle down' /></strong>}
          </Table.Cell>
          <Table.Cell data-cell={labels.nameOfSro}>
            <b>{data.documentName}</b>
          </Table.Cell>
          <Table.Cell data-cell={labels.identifier}>{!data.shortId ? 'Nevyplnené' : data.shortId}</Table.Cell>
          <Table.Cell data-cell={labels.stateOfOrder}>
            {data.orderStatus?.actualStatus?.state
              ? OrderStateText[data.orderStatus.actualStatus.state as OrderState]
              : OrderStateText[OrderState.VYTVORENE]}
          </Table.Cell>
          <Table.Cell data-cell={labels.dateOfCreate}>
            <span>{new Date(data.updated_at).toLocaleString()}</span>
          </Table.Cell>
        </Table.Row>
      }
      {data.template && formState &&
        <Table.Row >
          <Table.Cell onClick={() => {
            window.open(
              `/flow/${formState.flowId}?steps=${formState.selectedSteps.join(",")}&order=${data._id.toString()}`
              , "_blank")
          }}>
            <strong style={{ cursor: 'pointer' }}>Editovať <EditOutlined /></strong>
          </Table.Cell>
          <Table.Cell>
          </Table.Cell>
          <Table.Cell>
            <b>{data.documentName}</b>
          </Table.Cell>
          <Table.Cell>
            {!data.shortId ? 'Nevyplnené' : data.shortId}
          </Table.Cell>
          <Table.Cell>
            Rozpracovaná
          </Table.Cell>
          <Table.Cell>
            {<span>{new Date(data.updated_at).toLocaleString()}</span>}
          </Table.Cell>
        </Table.Row>
      }
      {showDetail &&
        data.template === undefined &&
        (
          <Table.Row className='userProfileTableRow'>
            <Table.Cell colspan="9">
              <Card className='userFiles'>
                {Object.entries(documentsToSign).map(([signature, doclist]) => {
                  return (
                    <>
                      <Segment className='userProfileWhoSignTitle'>
                        <div >{translations.screens.UserOrderList?.whoSign}</div>
                      </Segment>
                      <div className='userProfileWhoSign'>
                        <h4>{signature}</h4>
                        {doclist.map((documentItem: any) => {
                          return (
                            renderDocumentItem(documentItem, signature)
                          )
                        }
                        )}
                      </div>
                    </>
                  )
                }
                )}

                {noneSignedDocuments?.some((doc: any) => doc) && (
                  <>
                    <Segment className='userProfileOtherDocumentsTitle'>
                      <div>{translations.screens.UserOrderList?.otherDocuments}</div>
                    </Segment>
                    <div className='userProfileWhoSign'>
                      {noneSignedDocuments.map((documentItem: any) => {
                        if (!documentItem) {
                          return null;
                        }
                        return renderDocumentItem(documentItem, undefined);
                      })}
                    </div>
                  </>
                )}

                <div className='documentDownloadButtonContainer'>
                  <Button size="large" type="primary" disabled={!data.downloads}
                    onClick={() => handleTriggerDownloadAll(data.downloads)}
                  >
                    {translations.artifacts.DocumentsDownload?.downloadAll}
                  </Button>
                </div>

                <Divider className='ecoFriendlyDivider' />
                <div className='ecoFriendlyFooter'>
                  <img src={ecofriendly} alt='eco friendly' />
                  <div>
                    <h3>Podpíšte dokumenty ekologicky</h3>
                    <p>Elektronickým podpísaním dokumentov prispievate k zníženiu uhlíkovej stopy aj ochrane lesov. Za rok vieme takto spoločne znížiť <strong>uhlíkovú stopu o cca 75 ton CO<span style={{ fontSize: 10 }}>2</span></strong> a ušetriť <strong>vyrúbanie 1000 stromov.</strong></p>
                  </div>
                </div>
              </Card>
            </Table.Cell>
          </Table.Row>
        )}
      <div className='container'>
        <Modal className='feedbackModal' title="Poviete nám, ako ste s nami spokojní?" visible={isModalOpen} footer={[
          <Button type="primary" onClick={sendFeedback}>Odoslať hodnotenie</Button>
        ]}>
          <div className='ratingStarsContainer'>
            {[...Array(5)].map((star, i) => {
              const currentRating = i + 1
              return (
                <label>
                  <input type="radio" name="rating" value={currentRating} onClick={() => setRating(currentRating)} />
                  <StarTwoTone
                    className='star'
                    twoToneColor={currentRating <= (hover || rating) ? "#74c078" : "#e4e5e9"}
                    onMouseEnter={() => setHover(currentRating)}
                    onMouseLeave={() => setHover(0)}
                  />
                </label>
              )
            })}
          </div>
          <div className='textareaContainer'>
            <span>Vaše hodnotenie:</span>
            <TextArea
              id='feedbackTextarea'
              className='feedbackTextarea'
              value={feedbackMessage}
              onChange={handleChangeFeedback}
            ></TextArea>
          </div>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = ({ appState }: { appState: AppState }) => ({
  user: appState.cognitoUser,
});

interface DispatchProps {
  saveNote: (note: string, orderId: string) => void;
  uploadSignedFile: (orderId: string, documentIndex: string, fileData: any) => void;
  saveFeedback: (marketingId: string, rating: number, feedbackMessage: string) => void;
  uploadSignatureImage: (orderId: string, documentIndex: string, signature: any, fileData: any) => void;
  deleteSignatureImage: (orderId: string, documentIndex: string, signature: any) => void;
  createFileSignRequest: (fileSignRequest: any) => void;
  deleteFileSignRequest: (fileSignRequest: any) => void;
}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
  return {
    saveNote: (note: string, orderId: string) => dispatch(UpdateNoteAction(note, orderId)),
    uploadSignedFile: (orderId: string, documentIndex: string, fileData: any) => dispatch(UploadSignedFileCustomerAction(orderId, documentIndex, fileData)),
    uploadSignatureImage: (orderId: string, documentIndex: string, signature: any, fileData: any) => dispatch(UploadSignatureImageCustomerAction(orderId, documentIndex, signature, fileData)),
    deleteSignatureImage: (orderId: string, documentIndex: string, signature: any) => dispatch(DeleteSignatureImageCustomerAction(orderId, documentIndex, signature)),
    saveFeedback: (marketingId: string, rating: number, feedbackMessage: string) => dispatch(SaveFeedbackAction(marketingId, rating, feedbackMessage)),
    createFileSignRequest: (fileSignRequest: any) => dispatch(CreateFileSignRequestAction(fileSignRequest)),
    deleteFileSignRequest: (fileSignRequest: any) => dispatch(DeleteFileSignRequestAction(fileSignRequest))
  };
}

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(UserOrderItem);
